define('views/pages/multi-account/table',['require','underscore','lib/utils','helpers/application','views/base/table'],function(require) {
    'use strict';

    var     _ = require('underscore'),
        utils = require('lib/utils'),
        helpers = require('helpers/application'),

        View = require('views/base/table');

    function renderMoney(value, t, row) {
        return value ? (utils.money(value) + ' <small>' + row.currencyCode + '</small>') : '';
    }

    var AccountsTableView = View.extend({
        region: 'accounts-table',

        events: {
        },

        listen: {
            'redraw': 'onRedraw'
        },

        attributes: {
            style: 'float: left; width: 100%'
        },

        columns: [
            { data: 'docDate',        title: 'Дата документа', className: '', render: utils.date, sortable: false  },
            { data: 'docCode',        title: 'Документ №',     className: '', sortable: false },
            { data: 'debit',          title: 'Дебет',          className: 'text-right column-debit', sortable: false, render: renderMoney },
            { data: 'credit',         title: 'Кредит',         className: 'text-right column-credit', sortable: false, render: renderMoney },
            { data: 'saldo',          title: 'Сальдо',         className: 'text-right', sortable: false, render: renderMoney },
            { data: 'article',        title: 'Основание',      className: '', sortable: false },
            { data: 'contractorName', title: 'Контрагент',     className: '', sortable: false,
                render: function(contractorName, t, item) {
                    if (item.contractorId) {
                        var s = helpers.execute('openOrganizationCard', item.contractorId).split('"').join('\'');
                        return '<a href="javascript:' + s + '">' + contractorName + '</a>';
                    } else {
                        return 'Система';
                    }
                }
            }
        ],

        createTooltip: function(){
            this.$('[data-toggle=tooltip]').tooltip({ container: 'body' });
        },

        destroyTooltip: function(){
            this.$('[data-toggle=tooltip]').tooltip('destroy');
        },

        dispose: function() {
            if (this.disposed) { return; }
            this.destroyTooltip();
            View.prototype.dispose.apply(this, arguments);
        },

        onRedraw: function() {
            this.createTooltip();
        }
    });

    return AccountsTableView;
});

